import CommonState from './CommonState'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

/**
 * BillingConstants 常量定义
 */

/**
 * 账单状态
 */
export const BILLING_NOT_PRINTED = new CommonState(-1, '未打印', 'NotPrinted')
export const BILLING_NORMAL = new CommonState(0, '未确认', 'Normal')
export const BILLING_VERIFIED = new CommonState(1, '已确认', 'Verified')
export const BILLING_INVOICED = new CommonState(2, '已打印', 'Printed')
export const BILLING_INVALID = new CommonState(3, '已作废', 'Invalid')
export const BILLING_COMMITED = new CommonState(4, '已提交', 'Committed')
export const BILLING_RECEIVED = new CommonState(5, '已接受', 'Received')
export const BILLING_CUSTOMER_CHECKED = new CommonState(11, '客户已确认', 'Customer Checked')
export const BILLING_STATE_REVIEWED = new CommonState(12, '已复核', 'Reviewed')
export const BILLING_STATE_NOT_REVIEW = new CommonState(13, '未复核', 'Not review')

/**
 * 账单状态列表
 */
export const BILLING_STATES = new Set([
  BILLING_NOT_PRINTED,
  BILLING_NORMAL,
  BILLING_VERIFIED,
  BILLING_INVOICED,
  BILLING_INVALID,
  BILLING_COMMITED,
  BILLING_RECEIVED
])

export const UNCOMMITTED = new CommonState(2, '未提交', 'Not Submitted')
export const SUBMITTED = new CommonState(4, '已提交', 'Submitted')
export const ACCEPTED = new CommonState(5, '已接受', 'Accepted')
export const BILLING_STATE_ALL = new CommonState(-2, '全部', 'ALL')
export const BILLING_OVERSEAS_STATES = new Set([
  UNCOMMITTED,
  SUBMITTED,
  ACCEPTED,
  BILLING_STATE_ALL
])

export const VERIFICATION_ALL = new CommonState('4', '全部', 'ALL')
export const NOT_AllVERIFICATION = new CommonState('0', '未核销', 'Non-Write')
export const ALL_VERIFICATION = new CommonState('2', '全部核销', 'Full Writeoff')
export const PARTS_VERIFICATION = new CommonState('1', '部分核销', 'Partial Writeoff')

/**
 * 对账新版-账单类型-费用核销状态
  */
export const BILLING_RECEIVABLE_FINANCE = new Set([
  ALL_VERIFICATION,
  NOT_AllVERIFICATION,
  PARTS_VERIFICATION
])

/**
 * 只有国内的算内国账单，其它的都算是国外账单
 */
export const BILLING_TYPE_INTERNAL = new CommonState('国内账单', '国内账单', 'Domestic Bill')
export const BILLING_TYPE_OVERSEA = new CommonState('国外账单', '国外账单', 'Foreign bill')
export const BILLING_TYPE_NORMAL = new CommonState('普通账单', '普通账单', 'Regular Bill')
export const BILLING_TYPE_AGENT = new CommonState('代理分成账单', '代理分成账单', 'Agent Commission Bill')

/**
 * 账单类型列表
 */
export const BILLING_TYPE = new Set([
  BILLING_TYPE_INTERNAL,
  BILLING_TYPE_OVERSEA,
  BILLING_TYPE_NORMAL,
  BILLING_TYPE_AGENT
])

/**
 * 账单类型列表 (去掉代理分成账单)
 */
export const BILLING_TYPE2 = new Set([
  BILLING_TYPE_INTERNAL,
  BILLING_TYPE_OVERSEA,
  BILLING_TYPE_NORMAL
])

export const BILLING_TYPE3 = new Set([
  BILLING_TYPE_INTERNAL,
  BILLING_TYPE_OVERSEA
])

/**
 * 开票状态
 */
export const INVOICE_STATE_NOT_INVOICE = new CommonState(0, '未开票', 'Not Invoiced')
export const INVOICE_STATE_HALF = new CommonState(1, '部分开票', 'Half Invoiced')
export const INVOICE_STATE_FULL = new CommonState(2, '全部开票', 'All Invoiced')

/**
 * 账单-发票状态列表
 */
export const BILLING_INVOICE_STATES = new Set([
  INVOICE_STATE_NOT_INVOICE,
  INVOICE_STATE_HALF,
  INVOICE_STATE_FULL
])

/**
 * 费用状态
 */
export const CHARGE_STATE_NORMAL = new CommonState(0, '未提交', 'Normal')
export const CHARGE_STATE_SUBMIT = new CommonState(1, '已提交', 'Submit')
export const CHARGE_STATE_VERIFIED = new CommonState(2, '已审核', 'Verified')

/**
 * 费用状态列表
 */
export const CHARGE_STATE_STATES = new Set([
  CHARGE_STATE_NORMAL,
  CHARGE_STATE_SUBMIT,
  CHARGE_STATE_VERIFIED
])

export const BILL_UN_BILLED = new CommonState(0, '未开账单', 'Unbilled')
export const BILL_ISSUED = new CommonState(1, '已开账单', 'Issued')

/**
 * 是否已开账单
 */
export const BILLED_STATES = new Set([
  BILL_UN_BILLED,
  BILL_ISSUED
])

export const REQUEST_WITHDRAW = new CommonState(1, '已申请付款', 'Request withdraw')
export const NOT_REQUEST_WITHDRAW = new CommonState(0, '未申请付款', 'Not request withdraw')

/**
 * 是否已开账单
 */
export const REQUEST_WITHDRAW_STATES = new Set([
  REQUEST_WITHDRAW,
  NOT_REQUEST_WITHDRAW
])

/**
 * 账单确认状态
 */
export const BILLING_CONFIRMED_STATES = new Set([
  BILLING_NORMAL,
  BILLING_VERIFIED
])

// 账单复核状态
export const BILLING_NOT_REVIEW = new CommonState(0, '未复核', 'Not review')
export const BILLING_REVIEWED = new CommonState(1, '已复核', 'Reviewed')
export const BILLING_REVIEW = [BILLING_NOT_REVIEW, BILLING_REVIEWED]

export const TICKET_PAYMENT = new CommonState(1, '票结', 'Ticket Payment')
export const MONTH_PAYMENT = new CommonState(2, '月结', 'Month Payment')
export const PREPAYMENT = new CommonState(3, '预付', 'Prepayment')

/**
 * 结算类型
 */
export const SETTLEMENT_TYPE_STATES = new Set([
  TICKET_PAYMENT,
  MONTH_PAYMENT,
  PREPAYMENT
])

export const BILLING_NOT_CONFIRMED_STATE = new CommonState('0', '未确认', 'billingNotConfirmed')
export const BILLING_CONFIRMED_STATE = new CommonState('1', '已确认', 'billingConfirmed')
export const BILLING_REVIEWED_STATE = new CommonState('2', '已复核', 'billingReviewed')
